var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Row, Col, Grid } from "react-bootstrap";
import styled from "styled-components";
import { connect } from "@irati/store";
import { H2 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { FormattedMessage } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { BannerCard } from "../Wallet";
var StyledDiv = styled("div")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 40px 0;\n  text-align: ", ";\n"], ["\n  margin: 40px 0;\n  text-align: ", ";\n"])), function (_a) {
    var isMobile = _a.isMobile;
    return (isMobile ? "center" : "inherit");
});
var RewardBanner = /** @class */ (function (_super) {
    __extends(RewardBanner, _super);
    function RewardBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardBanner.prototype.render = function () {
        var isMobile = this.props.isMobile;
        var showRewardWallet = authentication.apps("wallet.rewardWallet");
        return (React.createElement(Grid, null,
            React.createElement(StyledDiv, { isMobile: isMobile },
                React.createElement(Grid, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 12, sm: 4, lg: 4 },
                            React.createElement(H2, { small: true },
                                React.createElement(FormattedMessage, { id: "reward.banner.header" })),
                            React.createElement(Row, null,
                                React.createElement(Col, { xsHidden: true, sm: 12 },
                                    React.createElement(Para, { large: true, center: isMobile },
                                        React.createElement(FormattedMessage, { id: "reward.banner.para" }))))),
                        showRewardWallet &&
                            React.createElement(Col, { xs: 12, smOffset: 1, sm: 6 },
                                React.createElement(BannerCard, null)))))));
    };
    return RewardBanner;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.md
    });
};
export default connect(mapStateToProps)(RewardBanner);
var templateObject_1;
